import { AppointmentTask } from './types';

export const selectNextActiveTask = (tasks: AppointmentTask[]) => {
  const now = Date.now();

  const processableTasks = tasks.filter(
    (task) => !task.retry?.nextRetryAt || task.retry.nextRetryAt <= now,
  );

  const prepareAudioRecordsTask = processableTasks.find(
    (t) => t.type === 'TASK.PREPARE_AUDIO_RECORDS',
  );

  if (prepareAudioRecordsTask) {
    return prepareAudioRecordsTask;
  }

  const nonMarkAppointmentCompleteTask = processableTasks.find(
    (t) => t.type !== 'TASK.GENERATE_NOTE',
  );

  if (nonMarkAppointmentCompleteTask) {
    return nonMarkAppointmentCompleteTask;
  }

  const [task] = processableTasks;
  return task;
};
